import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Buildings, ShoppingBag, Users, CreditCard, Crown, SignOut, Lightning, ChartBar } from "@phosphor-icons/react";

const items = [
  { to: "/super-admin", icon: ChartBar, label: "Overview", end: true },
  { to: "/super-admin/stores", icon: Buildings, label: "Stores" },
  { to: "/super-admin/orders", icon: ShoppingBag, label: "Orders" },
  { to: "/super-admin/customers", icon: Users, label: "Customers" },
  { to: "/super-admin/subscriptions", icon: Crown, label: "Subscriptions" },
  { to: "/super-admin/payments", icon: CreditCard, label: "Payments" },
];

export default function SuperLayout() {
  const { logout } = useAuth();
  const nav = useNavigate();

  return (
    <div className="min-h-screen bg-[#F9F9F9]">
      <div className="flex">
        <aside className="hidden lg:flex flex-col w-64 min-h-screen border-r border-gray-100 bg-gray-900 text-white sticky top-0">
          <div className="p-5 border-b border-white/10">
            <div className="flex items-center gap-2">
              <div className="w-9 h-9 rounded-xl bg-[#F8CB46] flex items-center justify-center">
                <Lightning weight="fill" size={20} className="text-black" />
              </div>
              <div>
                <div className="font-heading font-black tracking-tight">QuickDukaan</div>
                <div className="text-xs text-[#F8CB46]">Platform Admin</div>
              </div>
            </div>
          </div>
          <nav className="flex-1 p-3 space-y-1">
            {items.map((it) => (
              <NavLink key={it.to} to={it.to} end={it.end}
                data-testid={`super-nav-${it.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-semibold transition ${
                    isActive ? "bg-[#F8CB46] text-black" : "text-gray-300 hover:bg-white/5"
                  }`
                }>
                <it.icon weight="duotone" size={20} />
                {it.label}
              </NavLink>
            ))}
          </nav>
          <div className="p-3 border-t border-white/10">
            <button onClick={() => { logout(); nav("/super-admin/login"); }} className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-semibold text-red-400 hover:bg-red-500/10" data-testid="super-logout">
              <SignOut weight="duotone" size={20} /> Logout
            </button>
          </div>
        </aside>

        {/* Mobile top bar */}
        <div className="lg:hidden fixed top-0 inset-x-0 z-40 bg-gray-900 text-white px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-[#F8CB46] flex items-center justify-center">
              <Lightning weight="fill" size={16} className="text-black" />
            </div>
            <span className="font-heading font-black">Platform Admin</span>
          </div>
          <button onClick={() => { logout(); nav("/super-admin/login"); }} className="text-red-400"><SignOut size={20} /></button>
        </div>

        <main className="flex-1 min-w-0 lg:pt-0 pt-14 pb-20 lg:pb-8">
          <Outlet />
        </main>

        {/* Mobile bottom nav */}
        <nav className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-gray-900 text-white border-t border-white/10 px-2 py-2 flex justify-around">
          {items.map((it) => (
            <NavLink key={it.to} to={it.to} end={it.end}
              className={({ isActive }) => `flex flex-col items-center gap-0.5 px-2 py-1 ${isActive ? "text-[#F8CB46]" : "text-gray-400"}`}>
              <it.icon weight="duotone" size={20} />
              <span className="text-[10px] font-bold">{it.label}</span>
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
}
